import ConfirmModal from "components/ConfirmModal";
import { sidebarMenuStore } from "features/SidebarMenu/SidebarMenuStore";
import { observer } from "mobx-react-lite";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ROUTES_ENUM } from "routes/consts";
import { buildingStore } from "store/Building/BuildingStore";
import { organisationStore } from "features/Organisation/OrganisationStore";
import { buildingSettingsStore } from "../BuildingSettings/BuildingSettingsStore";
import { usePostHog } from "@posthog/react";

export default observer(function DeleteBuilding({
  open,
  close,
}: {
  open: boolean;
  close: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { t } = useTranslation();
  const { currentBuilding } = buildingStore;
  const navigate = useNavigate();
  const posthog = usePostHog();

  const deleteBuilding = async () => {
    const buildingId = currentBuilding?.id;
    const buildingName = currentBuilding?.name;
    await buildingSettingsStore.deleteBuilding().then(async () => {
      posthog.capture("building_deleted", {
        building_id: buildingId,
        building_name: buildingName,
      });
      await organisationStore.getAllOrganisations();
      await buildingStore.getOrganisationBuildings();
      await sidebarMenuStore.getCurrentOrgBuildings();
      navigate(`/${ROUTES_ENUM.DASHBOARD}`);
    });
  };

  const closeModal = useCallback(() => close(false), []);

  return (
    <ConfirmModal
      type="warning"
      open={open}
      close={closeModal}
      containerClassName="min-w-[500px]"
      title={t("buildingSettings.wantToDelete", {
        building_name: currentBuilding?.name,
      })}
      descriptionMesage={t("buildingSettings.deleteWarning")}
      confirmButtonTitle={t("buildingSettings.deleteBuilding")}
      onConfirm={deleteBuilding}
      buttonClassName="bg-red-600 hover:!bg-red-700"
      cancelTitle={t("commons.cancel")}
    ></ConfirmModal>
  );
});
